export default __webpack_public_path__ + "static/media/heading_city2.574a20d9.png";